import { useState } from "react";
import { Card, Flex } from "antd";
import { arrPartners } from "../data/arrPartners";
import { NavLink } from "react-router-dom";
const { Meta } = Card;

export default function Partners() {
  const [partners, setPartners] = useState(arrPartners);

  return (
    <main>
      <header>
        <h1>Partners</h1>
      </header>
      <section className="partners">
        <Flex
          vertical={false}
          wrap="wrap"
          gap={18}
          justify="flex-start"
          align="flex-start"
        >
          {partners.map((partner) => {
            // console.log(Object.values(partner.items.at(1))[2]);
            return (
              <NavLink
                to={`/partners/${partner.id}`}
                key={partner.id}
              >
                <Card
                  hoverable
                  style={{
                    width: 230,
                  }}
                  cover={
                    <img
                      className="partner-logo"
                      alt={partner.title}
                      src={"images/partners/" + partner.logo}
                    />
                  }
                >
                  <Meta title={partner.title} description={""} />
                </Card>
              </NavLink>
            );
          })}
        </Flex>
      </section>
    </main>
  );
}
